<button (click)="onClick()" [style.width]="width === 'full' ? '100%' : ''">{{label}} <i [className]="icon"></i></button>
